/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsalesendederror3Inputs */

const en_ticketsalesendederror3 = /** @type {(inputs: Ticketsalesendederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales of this ticket type have ended.`)
};

const de_ticketsalesendederror3 = /** @type {(inputs: Ticketsalesendederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Verkauf dieser Ticketart ist beendet.`)
};

/**
* | output |
* | --- |
* | "Sales of this ticket type have ended." |
*
* @param {Ticketsalesendederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsalesendederror3 = /** @type {((inputs?: Ticketsalesendederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsalesendederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsalesendederror3(inputs)
	return de_ticketsalesendederror3(inputs)
});
export { ticketsalesendederror3 as "ticketSalesEndedError" }